import { OP_SEARCH_ITEMS } from '@doda/common/src/constants/searchItems';
import { findJobCount } from 'components/IndustryModal/logics/createIndustryDisplayData';
import { EmployeeAverageAgeListType } from 'types/kodawari';
import { HooksArgument } from 'components/SearchSideBar/types';
import { EMPLOYEE_AVERAGE_AGE_CODE_AND_QUERY } from 'constants/searchCondition';
import { getInitialIdList } from '../getInitialIdList';

/**
 * 社員の平均年齢の初期状態を生成
 * @param param.savedSearchCondition 保存した検索条件のレスポンス
 * @param param.featuredSearchCondition 特集枠検索条件のレスポンス
 * @param param.queries クエリパラメータ
 * @param param.jobCountData 求人件数
 * @returns 社員の平均年齢の初期配列
 */
export const createInitialEmployeeAverageAgeList = ({
  savedSearchCondition,
  featuredSearchCondition,
  queries,
  jobCountData,
}: HooksArgument) => {
  const paramList = getInitialIdList({
    savedSearchCondition,
    featuredSearchCondition,
    queries,
  });

  const initialData: EmployeeAverageAgeListType[] = [
    {
      id: OP_SEARCH_ITEMS.twenties.id,
      name: OP_SEARCH_ITEMS.twenties.name,
      isChecked: paramList.some(
        (query) => query === OP_SEARCH_ITEMS.twenties.id
      ),
      value: EMPLOYEE_AVERAGE_AGE_CODE_AND_QUERY.TWENTY.code,
      jobCount: findJobCount(
        jobCountData.employeeAverageAgeList,
        EMPLOYEE_AVERAGE_AGE_CODE_AND_QUERY.TWENTY.code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.thirties.id,
      name: OP_SEARCH_ITEMS.thirties.name,
      isChecked: paramList.some(
        (query) => query === OP_SEARCH_ITEMS.thirties.id
      ),
      value: EMPLOYEE_AVERAGE_AGE_CODE_AND_QUERY.THIRTY.code,
      jobCount: findJobCount(
        jobCountData.employeeAverageAgeList,
        EMPLOYEE_AVERAGE_AGE_CODE_AND_QUERY.THIRTY.code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.forties.id,
      name: OP_SEARCH_ITEMS.forties.name,
      isChecked: paramList.some(
        (query) => query === OP_SEARCH_ITEMS.forties.id
      ),
      value: EMPLOYEE_AVERAGE_AGE_CODE_AND_QUERY.FORTY.code,
      jobCount: findJobCount(
        jobCountData.employeeAverageAgeList,
        EMPLOYEE_AVERAGE_AGE_CODE_AND_QUERY.FORTY.code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.overFifties.id,
      name: OP_SEARCH_ITEMS.overFifties.name,
      isChecked: paramList.some(
        (query) => query === OP_SEARCH_ITEMS.overFifties.id
      ),
      value: EMPLOYEE_AVERAGE_AGE_CODE_AND_QUERY.FIFTY.code,
      jobCount: findJobCount(
        jobCountData.employeeAverageAgeList,
        EMPLOYEE_AVERAGE_AGE_CODE_AND_QUERY.FIFTY.code
      ),
    },
  ];

  return initialData;
};
